const VMasker = require("vanilla-masker")


export const validate = function(type, value) {
    console.log('type, value', type, value)
    if (type == 'CNPJ') {
        var cnpj = value

        cnpj = cnpj.replace(/[^\d]+/g, '');

        if (cnpj == '') return false;

        if (cnpj.length != 14)
            return false;

        // Elimina CNPJs invalidos conhecidos
        if (cnpj == "00000000000000" ||
            cnpj == "11111111111111" ||
            cnpj == "22222222222222" ||
            cnpj == "33333333333333" ||
            cnpj == "44444444444444" ||
            cnpj == "55555555555555" ||
            cnpj == "66666666666666" ||
            cnpj == "77777777777777" ||
            cnpj == "88888888888888" ||
            cnpj == "99999999999999")
            return false;

        // Valida DVs
        var tamanho = cnpj.length - 2
        var numeros = cnpj.substring(0, tamanho);
        var digitos = cnpj.substring(tamanho);
        var soma = 0;
        var pos = tamanho - 7;
        for (var i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0))
            return false;

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (var i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
            return false;

        return true;
    } else if (type == 'CPF') {
        var cpf = value;
        cpf = cpf.replace(/\D/g, '');
        if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
        var result = true;
        [9, 10].forEach(function(j) {
            var soma = 0,
                r;
            cpf.split(/(?=)/).splice(0, j).forEach(function(e, i) {
                soma += parseInt(e) * ((j + 2) - (i + 1));
            });
            r = soma % 11;
            r = (r < 2) ? 0 : 11 - r;
            if (r != cpf.substring(j, j + 1)) result = false;
        });
        return result;
    } else if (type == 'email') {
        const email = value;
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    } else {
        return true;
    }
}


export const addMasksToView = function(formEl) {
    Array.from(formEl.getElementsByTagName("inputBox")).forEach((inputBox) => {
        const type = inputBox.getAttribute('type')
        const field = inputBox.getAttribute('field')
        console.log('type', type)
        console.log('inputBox', inputBox)
        console.log('getInputBoxByField(formEl, type)', getInputBoxByField(formEl, type))
        if (type == 'CNPJ') {
            VMasker(getInputBoxByField(formEl, field).input)
                .maskPattern("99.999.999/9999-99");
        } else if (type == 'CPF') {
            VMasker(getInputBoxByField(formEl, field).input)
                .maskPattern("999.999.999-99");
        } else if (type == 'phone') {
            const el = getInputBoxByField(formEl, field).input
            VMasker(el).maskPattern("(99) 9999-9999");
            el.addEventListener('keyup', (evt) => {
                // console.log('el', el)
                var phone = evt.srcElement.value,
                    digits = phone.replace(/\D/g, '');
                VMasker(evt.srcElement).unMask();
                // verify length of digits and apply correct mask pattern
                if (digits.length > 10) {
                    VMasker(evt.srcElement).maskPattern("(99) 99999-9999");
                } else {
                    VMasker(evt.srcElement).maskPattern("(99) 9999-9999");
                }
            })
        } else if (type == 'CEP') {
            VMasker(getInputBoxByField(formEl, field).input)
                .maskPattern("99999-999");
        } else if (type == 'number') {
            VMasker(getInputBoxByField(formEl, field).input).maskNumber();
        }
    })
}

export const enableOrDisableFieldsByParams = function(formEl) {
    Array.from(formEl.getElementsByTagName("inputBox")).forEach((inputBox) => {
        const requireParams = inputBox.getAttribute('requireParams')
        var enabled = true;
        if (requireParams) {
            const currentParams = getUrlAsObject(location.search.substring(1))
            console.log('currentParams', currentParams)
            console.log('requireParams', requireParams)

            Object.keys(requireParams).forEach((paramskey) => {
                if (currentParams[paramskey] && currentParams[paramskey] == requireParams[paramskey]) {
                    console.log('currentParams[paramskey]', currentParams[paramskey])
                    console.log('requireParams[paramskey]', requireParams[paramskey])
                    enabled = true;
                } else {
                    enabled = false;
                }
            })
        }

        if (enabled == false) {
            inputBox.remove()
        }

    })
}


export const getUrlAsObject = function(url) {
    var search = url;
    return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}



export const thisFormIsValid = function(formEL) {
    let imputsToValidation = [];
    Array.from(formEL.getElementsByTagName("inputBox")).forEach((e) => {
        const fieldName = e.getAttribute('field')
        const type = e.getAttribute('type')
        const required = e.getAttribute('isRequired')
        const friendlyName = e.getAttribute('friendlyName')
        imputsToValidation.push({
            fieldName: fieldName,
            type: type,
            required: required,
            friendlyName: friendlyName ? friendlyName : fieldName
        })
    })



    var errorFields = []

    imputsToValidation.forEach((input) => {
        var inputEl = getInputBoxByField(formEL, input.fieldName)
        console.log('inputEl', inputEl)
        console.log('input', input)
        // check if is required
        if ((input.required == 'true' && isEmpty(inputEl.input.value) && inputEl.input.type != 'checkbox') || (inputEl.input.type == 'checkbox' && inputEl.input.checked == false)) {
            errorFields.push({
                message: `O campo <strong>${input.friendlyName}</strong> é obrigatório`,
                fieldName: input.fieldName,
                type: input.type,
                required: input.required,
                inputEl: inputEl,
                friendlyName: input.friendlyName
            })
        } else {
            // check if is valid
            if (validate(input.type, inputEl.input.value) == false && (inputEl.input.value && inputEl.input.value != null && inputEl.input.value != '')) {
                errorFields.push({
                    message: `O campo <strong>${input.fieldName}</strong> é inválido`,
                    fieldName: input.fieldName,
                    type: input.type,
                    required: input.required,
                    inputEl: inputEl
                })
                return true
            } else {

            }
        }
    })

    // if there are errors it will add messages on the screen, otherwise it should return valid
    if (errorFields.length > 0) {
        addErrorMessagesToView(errorFields)
        return false
    } else {
        return true
    }

}



export const validateFromServer = function(formEL, errorsFromServer) {
    let imputsToValidation = [];
    var errorKeys = Object.keys(errorsFromServer)
    Array.from(formEL.getElementsByTagName("inputBox")).forEach((e) => {
        const fieldName = e.getAttribute('field')
        const type = e.getAttribute('type')
        const required = e.getAttribute('isRequired')
        const friendlyName = e.getAttribute('friendlyName')


        if (errorKeys.find((errorName) => errorName == fieldName)) {
            imputsToValidation.push({
                fieldName: fieldName,
                type: type,
                required: required,
                friendlyName: friendlyName ? friendlyName : fieldName
            })
        }

    })



    var errorFields = []

    imputsToValidation.forEach((input) => {
        var inputEl = getInputBoxByField(formEL, input.fieldName)
        console.log('inputEl', inputEl)
        console.log('input', input)
        // check if is required

        errorFields.push({
            message: errorsFromServer[input.fieldName],
            fieldName: input.fieldName,
            type: input.type,
            required: input.required,
            inputEl: inputEl,
            friendlyName: input.friendlyName
        })
    })

    // if there are errors it will add messages on the screen, otherwise it should return valid
    if (errorFields.length > 0) {
        addErrorMessagesToView(errorFields)
        return false
    } else {
        return true
    }

}

export const isEmpty = function(str) {
    return !str.trim().length;
}

export const addErrorMessagesToView = function(errorFields) {
    console.log('errorFields', errorFields)
    errorFields.forEach((erroeField, index) => {
        if (index == 0) {
            const yOffset = -100;
            const element = erroeField.inputEl.inputBox;
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

            window.scrollTo({
                top: y,
                behavior: 'smooth'
            });
        }
        erroeField.inputEl.inputBox.classList.add('invalid')
        erroeField.inputEl.errormessage.innerHTML = erroeField.message;
    })
}

export const getInputBoxByField = function(formEL, field) {
    var inputBoxEl = Array.from(formEL
        .getElementsByTagName('inputBox')).find((e) => {
        return e.getAttribute('field') == field;
    })

    if (inputBoxEl) {

        var inputEl = inputBoxEl.getElementsByTagName("input")[0]
        var errormessageEl = inputBoxEl.getElementsByTagName("errormessage")[0]

        if (inputBoxEl.getAttribute('inputType') && inputBoxEl.getAttribute('inputType') == 'radio') {
            var inputEls = inputBoxEl.getElementsByTagName("input");
            inputEl = Array.from(inputEls).find((el) => el.checked == true)

            if (!inputEl) {
                return undefined
            }
        }

        if (inputBoxEl.getAttribute('inputType') && inputBoxEl.getAttribute('inputType') == 'textarea') {
            var inputEls = inputBoxEl.getElementsByTagName("textarea");
            inputEl = inputEls[0]
            console.log('inputEl', inputEl)

            if (!inputEl) {
                return undefined
            }
        }

        if (inputBoxEl.getAttribute('inputType') && inputBoxEl.getAttribute('inputType') == 'select') {
            var inputEls = inputBoxEl.getElementsByTagName("select");
            inputEl = inputEls[0]
            // console.log('inputEl',inputEl)

            if (!inputEl) {
                return undefined
            }
        }

        // if (inputBoxEl.getAttribute('inputType') && inputBoxEl.getAttribute('inputType') == 'checkbox') {
        //     var inputEls = inputBoxEl.getElementsByTagName("checkbox");
        //     inputEl = inputEls[0]
        //     // console.log('inputEl',inputEl)
        //
        //     if (!inputEl) {
        //         return undefined
        //     }
        // }

        if (inputBoxEl.getAttribute('inputType') && inputBoxEl.getAttribute('inputType') == 'radio') {
            var inputEls = inputBoxEl.getElementsByTagName("input");
            inputEl = Array.from(inputEls).find((el) => el.checked == true)

            if (!inputEl) {
                return undefined
            }
        }


        // if(inputEl)
        return {
            inputBox: inputBoxEl,
            input: inputEl,
            errormessage: errormessageEl,
            value: inputEl.value,
            inputName: inputBoxEl.getAttribute('field')
        }
    } else {
        return undefined
    }

}


export async function getFormValues(formEl) {
    var formValues = {}
    Array.from(formEl.getElementsByTagName("inputBox"))
        .forEach((inputBox) => {

            const field = inputBox.getAttribute('field')
            const inputBoxPayload = getInputBoxByField(formEl, field)
            console.log('inputBoxPayload', inputBoxPayload)
            formValues[inputBoxPayload.inputName] = inputBoxPayload.value
        })

    return formValues;
}


/**
 * Updates form data.
 *
 * @param {object} formEl the form element you want to change.
 * @param {object} serverInfo the information coming from the server to update your form.
 * @return {void}.
 */
export async function setFormValues(formEl, serverInfo) {
    var formValues = {}
    Array.from(formEl.getElementsByTagName("inputBox"))
        .forEach((inputBox) => {

            const field = inputBox.getAttribute('field')
            const inputBoxPayload = getInputBoxByField(formEl, field)
            // check if there is a key with same name
            if (serverInfo[inputBoxPayload.inputName]) {
                inputBoxPayload.value = serverInfo[inputBoxPayload.inputName];
            }
        })

}


export const clearErrosMessages = function(formEl) {
    Array.from(formEl.getElementsByTagName("inputBox"))
        .forEach((inputBoxEl) => {
            inputBoxEl.classList.remove('invalid')
        })
}

export const getRouteByCurrentStep = function(step) {
    switch (step) {
        case "register":
            return "etapa_3"
        case "donation":
            return "etapa_3"
        case "profile":
            return "etapa_7"
        default:
            return "etapa_1"
    }
}
